import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgChartsModule } from 'ng2-charts';
import { StatusLablesComponent } from "../../shared/components/status-lables/status-lables.component";
import { EntityType } from '../../shared/share';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { PatientBulkuploadComponent } from '../../patient-bulkupload/patient-bulkupload.component';
import { AddPatientComponent } from '../../add-patient/add-patient.component';
import { RequestMedicalEvidenceComponent } from '../../request-medical-evidence/request-medical-evidence.component';
import { MedicalProviderListComponent } from '../../medical-provider-list/medical-provider-list.component';
import { MemberInsurerServiceService } from '@app/modules/lps-member-login/services/member-insurer-service.service';
import { SubmitMedicalEvidenceComponent } from '../../submit-medical-evidence/submit-medical-evidence.component';
import { Roles } from '@app/modules/lps-member-login/models/commonmodel';
import { PatientTableComponent } from "../../patient-table/patient-table.component";
import { MemberInsurerRestService } from '@app/modules/lps-member-login/services/member-insurer-rest.service';
import { Router } from '@angular/router';
import { NoDataFoundComponent } from "../../shared/no-data-found/no-data-found.component";
import { CountUpPipe } from '../../shared/pipes/count-up.pipe';
import { Subject } from 'rxjs';
import {
  ChartType,
  ChartOptions,
  ChartDataset,
  ChartConfiguration,
  Chart
} from 'chart.js';
import { InitialsPipe } from '../../shared/pipes/intials.pipe';


interface DashboardCard {
  value: number;
  title: string;
  color: string;
  icon?: string;
  symbol?: string;
  hoverTrigger$: Subject<void>; // Add a Subject to each card
}
@Component({
  selector: 'app-dashboard-view',
  standalone: true,
  imports: [MatIconModule, CommonModule, NgChartsModule, StatusLablesComponent, PatientTableComponent, NoDataFoundComponent,
    CountUpPipe, InitialsPipe
  ],
  templateUrl: './dashboard-view.component.html',
  styleUrl: './dashboard-view.component.scss'
})
export class DashboardViewComponent {

  constructor(private sanitizer: DomSanitizer, private dialog: MatDialog, private router: Router,
    public MemberInsurerServiceService: MemberInsurerServiceService, private restService: MemberInsurerRestService,
    private memberService: MemberInsurerServiceService
  ) { }

  enumEntityType = EntityType;
  enumRole = Roles;
  activeTab: string = 'overview';
  isSidebarExpanded: boolean = false;

  dashboardCards = [
    { title: 'Sent/Pending', value: 0, color: 'striped' },
    { title: 'More Info Requested', value: 0, color: 'outlined' },
    { title: 'Received', value: 0, color: 'green' },
  ];

  getSegmentClass(colorType: string): string {
    switch (colorType) {
      case 'dark':
        return 'segment-light-blue';
      case 'green':
        return 'segment-green';
      case 'striped':
        return 'segment-striped-orange';
      case 'outlined':
        return 'segment-outlined-pink';
      default:
        return '';
    }
  }

  dashboardCards2: any[] = [];

  svgIcons: { [key: string]: string } = {
    document: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><g fill="none" stroke="#0075C9" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2"><path d="M3.5 5c0 -0.83 0.67 -1.5 1.5 -1.5c0.83 0 1.5 0.67 1.5 1.5c0 0.83 -0.67 1.5 -1.5 1.5c-0.83 0 -1.5 -0.67 -1.5 -1.5Z"/><path d="M3.5 12c0 -0.83 0.67 -1.5 1.5 -1.5c0.83 0 1.5 0.67 1.5 1.5c0 0.83 -0.67 1.5 -1.5 1.5c-0.83 0 -1.5 -0.67 -1.5 -1.5Z"/><path d="M3.5 19c0 -0.83 0.67 -1.5 1.5 -1.5c0.83 0 1.5 0.67 1.5 1.5c0 0.83 -0.67 1.5 -1.5 1.5c-0.83 0 -1.5 -0.67 -1.5 -1.5Z"/><path d="M9.5 5c0 -0.83 0.67 -1.5 1.5 -1.5h8c0.83 0 1.5 0.67 1.5 1.5c0 0.83 -0.67 1.5 -1.5 1.5h-8c-0.83 0 -1.5 -0.67 -1.5 -1.5Z"/><path d="M9.5 12c0 -0.83 0.67 -1.5 1.5 -1.5h8c0.83 0 1.5 0.67 1.5 1.5c0 0.83 -0.67 1.5 -1.5 1.5h-8c-0.83 0 -1.5 -0.67 -1.5 -1.5Z"/><path d="M9.5 19c0 -0.83 0.67 -1.5 1.5 -1.5h8c0.83 0 1.5 0.67 1.5 1.5c0 0.83 -0.67 1.5 -1.5 1.5h-8c-0.83 0 -1.5 -0.67 -1.5 -1.5Z"/></g></svg>`,

    shopping_cart: `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 48 48"><path fill="green" fill-rule="evenodd" d="M20 4a3 3 0 0 0-3 3h-3a3 3 0 0 0-3 3v28a3 3 0 0 0 3 3h12v-2H14a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1h3a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3h3a1 1 0 0 1 1 1v15h2V10a3 3 0 0 0-3-3h-3a3 3 0 0 0-3-3zm-1 3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1zm4 12v-3h2v3h3v2h-3v3h-2v-3h-3v-2zm4 9a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v6.789a7 7 0 0 1-3.117 5.824l-3.328 2.22a1 1 0 0 1-1.11 0l-3.328-2.22A7 7 0 0 1 27 34.79zm2 1v5.789a5 5 0 0 0 2.227 4.16L34 40.8l2.773-1.85A5 5 0 0 0 39 34.79V29zm4.707 7.707l4-4l-1.414-1.414L33 34.586l-1.293-1.293l-1.414 1.414l2 2a1 1 0 0 0 1.414 0" clip-rule="evenodd"/></svg>`,

    people: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="orange" d="M6 4H4V2h16v2h-2v2c0 1.615-.816 2.915-1.844 3.977c-.703.726-1.558 1.395-2.425 2.023c.867.628 1.722 1.297 2.425 2.023C17.184 15.085 18 16.385 18 18v2h2v2H4v-2h2v-2c0-1.615.816-2.915 1.844-3.977c.703-.726 1.558-1.395 2.425-2.023c-.867-.628-1.722-1.297-2.425-2.023C6.816 8.915 6 7.615 6 6zm2 0v2c0 .685.26 1.335.771 2h6.458c.51-.665.771-1.315.771-2V4zm4 9.222c-1.045.738-1.992 1.441-2.719 2.192a7 7 0 0 0-.51.586h6.458a7 7 0 0 0-.51-.586c-.727-.751-1.674-1.454-2.719-2.192"/></svg>`,

    clock: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 48 48"><g fill="none" stroke="#0075C9" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"><path d="M29.14 42.987c5.119-.063 8.743-.344 11.108-.614c2.2-.252 3.85-1.903 4.092-4.105c.319-2.89.66-7.741.66-15.268c0-2.876-.05-5.361-.13-7.496c-.351-.982-1.55-3.568-5.266-7.21c-3.941-3.864-6.67-4.952-7.519-5.217A162 162 0 0 0 27 3c-6.264 0-10.566.32-13.248.627c-2.201.252-3.85 1.903-4.092 4.105c-.225 2.034-.46 5.04-.58 9.268"/><path d="M44.884 15.96c-2.087.31-5.84.072-8.688-.192a4.664 4.664 0 0 1-4.228-4.21c-.269-2.803-.507-6.468-.181-8.489M3 33a12 12 0 1 0 24 0a12 12 0 1 0-24 0"/><path d="m20 29l-5.882 8L10 32.333"/></g></svg>`
  };

  setActiveTab(tabName: string): void {
    this.activeTab = tabName;
    console.log('Active Tab:', this.activeTab); // For demonstration
  }

  private thickerColors = [
    'green', // Darker greenish for Medical Evidence Received
    '#6699CC', // Darker blue for More Info Requested
    'rgb(245 222 4)', // Darker yellow for Sent/Pending Requests
    '#0075C9'  // Darker blue for Total Evidence Requests
  ];

  public chartType: ChartType = 'doughnut';

  public chartData: ChartConfiguration['data'] = {
    labels: [
      'Medical Evidence Received',
      'More Info Requested',
      'Sent/Pending Requests',
      'Total Evidence Requests' // Added this label
    ],
    datasets: [
      {
        data: [
          5,    // Medical Evidence Received
          12,   // More Info Requested
          30,   // Sent/Pending Requests
          // Assuming 'Total Evidence Requests' is a sum for the chart, or a distinct value
          5 + 12 + 30 // Calculated total for chart segment (47)
        ],
        backgroundColor: [
          '#C9F2DF',
          '#C9DFEE',
          '#FDFECD',
          '#A7E4F2' // Color for Total Evidence Requests
        ],
        borderColor: '#ffffff',
        borderWidth: 2,
      }
    ]
  };

  public chartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
        position: 'right', // <-- this positions it on the right
      },
      tooltip: {
        mode: 'index',
        intersect: false,
        backgroundColor: '#fff',
        borderColor: '#ccc',
        borderWidth: 1,
        titleColor: '#222',
        bodyColor: '#333',
        padding: 10,
        callbacks: {
          label: function (context) {
            const label = context.label || '';
            const value = context.raw as number;
            return `${label}: ${value}`;
          }
        }
      }
    },
    scales: {}
  };

  // Data for the boxes below the chart
  // Using null-assertion operator `!` and explicit type casting for simplicity,
  // assuming these values are always present after initialization.
  // For more robust applications, consider getters as discussed previously.
  public medicalEvidenceReceivedCount: number = this.chartData.datasets[0].data[0] as number;
  public moreInfoRequestedCount: number = this.chartData.datasets[0].data[1] as number;
  public sentPendingRequestsCount: number = this.chartData.datasets[0].data[2] as number;
  public totalCount: number = this.chartData.datasets[0].data[3] as number; // This will now correctly access the 4th data point

  public medicalEvidenceReceivedColorThick: string = this.thickerColors[0];
  public moreInfoRequestedColorThick: string = this.thickerColors[1];
  public sentPendingRequestsColorThick: string = this.thickerColors[2];
  public totalColorThick: string = this.thickerColors[3];


  ngOnInit(): void {

    this.memberService.sidebarExpanded$.subscribe((expanded) => {
      console.log('Sidebar expanded state:', expanded);
      if (expanded) {
        this.isSidebarExpanded = false;
      } else {
        this.isSidebarExpanded = true;
      }
    });

    const legendMarginPlugin = {
      id: 'legendMargin',
      beforeInit(chart: any) {
        const fitValue = chart.legend.fit;
        chart.legend.fit = function () {
          fitValue.bind(chart.legend)();
          this.height += 40;
        };
      }
    };

    Chart.register(legendMarginPlugin);

    const initialValues = [
      { title: 'Sent/Pending Requests', value: 0, icon: 'people', color: 'gradient-orange' },
      { title: 'More info Requested', value: 0, icon: 'clock', color: 'gradient-pink' },
      { title: 'Medical Evidence Received', value: 0, icon: 'shopping_cart', color: 'gradient-green' },
      { title: 'Total Evidence Requests', value: 0, icon: 'document', symbol: '$', color: 'gradient-blue' }
    ];

    this.dashboardCards2 = initialValues.map(card => ({
      ...card,
      hoverTrigger$: new Subject<void>()
    }));

    this.memberService.sidebarExpanded$.subscribe((expanded) => {
      console.log('Sidebar expanded state:', expanded);
      if (expanded) {
        this.isSidebarExpanded = false;
      } else {
        this.isSidebarExpanded = true;
      }
    });

    this.memberService.refreshDashboard$.subscribe(() => {
      this.getLatestReq();
    });

    this.getLatestReq();
    this.getDashboardCounts();

    this.MemberInsurerServiceService.tabChanged$.subscribe(tab => {
      console.log('Received tab:', tab);
      this.activeTab = tab;
      // react to tab change
    });
  }

  getLatestReq() {
    this.patientsList = [];
    this.restService.getAllLatestReqToInsurer().subscribe(res => {
      if (res) {
        this.patientsList = res;
      }
    }, err => {
      this.patientsList = [];
    })
  }

  onCardClick(index: number) {
    this.router.navigate(['/dashboard/applicants'], {
      state: { index }
    });
  }

  onReqClick(patient: any) {
    this.router.navigate(['/dashboard/applicants'], {
      state: { id: patient.firstName }
    });
  }

  dashboardData: any;
  getDashboardCounts() {
    this.dashboardData = [];
    let userId = this.memberService.getLoginUserId();

    this.restService.getInsurerLast6MonthsData(userId).subscribe(res => {
      if (res) {
        this.dashboardData = res;

        const requested = res.REQUESTED || 0;
        const moreInfoRequested = res.MORE_INFO_REQUESTED || 0;
        const received = res.RECEIVED || 0;

        const total = requested + moreInfoRequested + received;

        // Set raw count values
        this.dashboardCards2[0].value = requested;
        this.dashboardCards2[1].value = moreInfoRequested;
        this.dashboardCards2[2].value = received;
        this.dashboardCards2[3].value = total; // if needed

        // Set percentage values (ensuring they add to 100% and are rounded up)
        this.dashboardCards[0].value = total ? Math.floor((requested / total) * 100) : 0;
        this.dashboardCards[1].value = total ? Math.floor((moreInfoRequested / total) * 100) : 0;
        this.dashboardCards[2].value = total ? Math.floor((received / total) * 100) : 0;

      }
    }, err => {
      this.dashboardData = [];
    });
  }


  getSanitizedSvg(iconName: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.svgIcons[iconName] || '');
  }

  goToMembersTab() {
    this.activeTab = 'members';
    this.MemberInsurerServiceService.sideBarchangeTab(this.activeTab);
  }

  patientsList: any[] = [];

  goToPatients(): void {
    this.router.navigate(['/dashboard/applicants']);
  }

  openBulkUploadModal() {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.width = '900px';
    // dialogConfig.height = '500px';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.enterAnimationDuration = 200;
    const dialogRef = this.dialog.open(PatientBulkuploadComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm) {

      }
    });
  }

  onCardHover(card: DashboardCard): void {
    card.hoverTrigger$.next(); // Emit a value to trigger the pipe
  }

  openMedicalEvidence() {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.width = '700px';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.enterAnimationDuration = 200;
    const dialogRef = this.dialog.open(SubmitMedicalEvidenceComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm) {

      }
    });
  }

  openAddMedicalProviderModal() {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.width = '600px';
    dialogConfig.height = '600px';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.enterAnimationDuration = 200;
    const dialogRef = this.dialog.open(MedicalProviderListComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm) {

      }
    });
  }

  openAddPatientModal() {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.width = '900px';
    dialogConfig.height = '600px';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.enterAnimationDuration = 200;
    const dialogRef = this.dialog.open(AddPatientComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm) {

      }
    });
  }

  openRequestME() {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.width = '900px';
    dialogConfig.height = '800px';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.enterAnimationDuration = 200;

    const dialogRef = this.dialog.open(RequestMedicalEvidenceComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm) {

      }
    });
  }

}
